import React from 'react';
import {
  ExpandableNavigationItem,
  ExpandableNavigationItemIcon,
  ExpandableNavigationItemLink,
  ExpandableNavigationItemLinkProps,
  ExpandableNavigationItemText,
} from 'app/src/components/ExpandableNavigation';
import { HomeTestIds } from '@trello/webdriverio-tests';
import styles from './navigation.less';
import { forTemplate } from 'app/common/lib/util/i18n';
const format = forTemplate('home');

export interface HomeTabProps extends ExpandableNavigationItemLinkProps {
  shouldShowNewLozenge?: boolean;
}

export const HomeTab: React.FunctionComponent<HomeTabProps> = ({
  shouldShowNewLozenge,
  ...props
}) => (
  <ExpandableNavigationItem>
    <ExpandableNavigationItemLink
      data-test-id={HomeTestIds.HomeLink}
      {...props}
    >
      <ExpandableNavigationItemIcon iconName="home" />
      <ExpandableNavigationItemText>
        {format('home')}
        {shouldShowNewLozenge && (
          <>
            &nbsp;
            <span className={styles.navigationItemNewLozenge}>
              {format('new')}
            </span>
          </>
        )}
      </ExpandableNavigationItemText>
    </ExpandableNavigationItemLink>
  </ExpandableNavigationItem>
);
